import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25fed1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "text-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSwitchCategoryType && _ctx.handleSwitchCategoryType(...args)))
    }, _toDisplayString(_ctx.categoryType === "CATALOG"
          ? "Изменить на Продуктовую"
          : "Изменить на Разводящую"), 1)
  ]))
}